import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { AlarmGroup } from 'icreate/common/models/alarm-group';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AlarmGroupService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId: string): Promise<AlarmGroup[]> {
        return await lastValueFrom(
            this.http.get<AlarmGroup[]>(`${this.domain}/api/alarmGroup`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getAllForPrint(vesselId: string): Promise<AlarmGroup[]> {
        return await lastValueFrom(
            this.http.get<AlarmGroup[]>(`${this.domain}/api/alarmGroup/print`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async moveItem(groupNo: number, toGroupNo: number, vesselId: string) {
        return await lastValueFrom(
            this.http.post(`${this.domain}/api/alarmGroup/move`, {
                groupNo,
                toGroupNo,
                vesselId,
            })
        );
    }

    async saveAll(AlarmGroupList: AlarmGroup[], vesselId) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/alarmGroup/upsertAll/${vesselId}`,
                { alarmGroupList: AlarmGroupList },
                { headers: this.headers }
            )
        );
    }
}
